import { AlphaJIcon } from './AlphaJIcon';

/**
 * author: GreenTurtwig
 * id C964FFC4-AA90-4AF6-B604-352082207789
 * name alpha-j
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-j.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterJIcon = AlphaJIcon;
export default LetterJIcon